import { CSSProperties, useContext, useEffect, useState } from "react";
import { makeKey, objectToArrayInOrder, styx, clsx, smartGoBack } from "modules/Utils";
import PageSymphony from "elements/PageSymphony";
import useScreen from "Hooks/useScreen";
import TopBar from "components/shareable/TopBar/TopBar";
import { useHistory, useParams, useLocation } from "react-router-dom";
import Sty from "modules/Sty";
import Icon from "elements/Icon";
import Colors from "modules/Colors";
import ButtonSymphony, { ButtonColor, ButtonVariant } from "elements/ButtonSymphony";
import CardSymphony from "elements/CardSymphony";
import useWebsiteBuilder, {
    CollectDataInputType,
    DividerStyle,
    ExternalLinksStyle,
    getWebsiteBuilderContentInfo,
    ImageContentStyle,
    MusicContentStyle,
    PresavePlatform,
    PresaveWebsiteBuilderStyle,
    StreamingPlatformsStyle,
    TourStyle,
    VideoContentStyle,
    WebsiteBuilderContent,
    WebsiteBuilderContentType,
    WebsiteTextAlign
} from 'Hooks/useWebsiteBuilder';
import TextContent from "components/websiteBuilder/content/TextContent";
import ImageContent from "components/websiteBuilder/content/ImageContent";
import StreamingPlatformsContent from "components/websiteBuilder/content/StreamingPlatformsContent";
import SocialPlatformsContent from "components/websiteBuilder/content/SocialPlatformsContent";
import TabsContent from "components/websiteBuilder/content/TabsContent";
import MusicContent from "./content/MusicContent";
import DividerContent from "./content/DividerContent";
import ImagePalette from "elements/ImagePalette";
import PaymentContent from "./content/PaymentContent";
import ModalSymphony from "elements/ModalSymphony";
import useBrand, { BrandExistsState } from "Hooks/useBrand";
import Loader from "elements/Loader";
import DebugBox from "components/shareable/DebugBox";
import TourContent from "./content/TourContent";
import PresaveContent from "./content/PresaveContent";
import dayjs from "dayjs";
import CollectDataContent from "components/websiteBuilder/content/CollectDataContent";
import ConnectSection from "pages/WebsitePage/components/CustomizeWebsite/components/ConnectSection/ConnectSection";
import { fontThemeStyles, PlanType, SYMPHONY_WEBSITE_URL } from "modules/Const";
import { DraggableList } from "components/shareable/DraggableList";
import $ from "jquery";
import OptionsSymphony from "elements/OptionsSymphony";
import WebsiteBuilderPhonePreview from "./WebsiteBuilderPhonePreview";
import { TabItem } from "elements/TabsSymphony";
import InputSymphony, { SelectOptionItem } from "elements/InputSymphony";
import ExternalLinksContent from "./content/ExternalLinksContent";
import VideosContent from "./content/VideoContent";
import TabsSymphony from "elements/TabsSymphony";
import TabSymphony from "elements/TabSymphony";
import PublishedWebsiteModal from "pages/WebsitePage/components/CustomizeWebsite/components/PublishedWebsiteModal";
import WebsiteShareModal from "./WebsiteShareModal";
import WebsiteBuilderEmptyState from "./WebsiteBuilderEmptyState";
import useWebsiteBuilderAnalytics from "Hooks/useWebsiteBuilderAnalytics";
import WebsiteBuilderAnalytics from "./WebsiteBuilderAnalytics";
import { UpgradeModalContext } from "Hooks/UpgradeModalContext";
import { toast } from "react-toastify";
import SymphonyLogoEditorCard from "pages/WebsitePage/components/SymphonyLogoEditorCard";
import UpgradeToUnlockCTA from "pages/WebsitePage/components/CustomizeWebsite/components/UpgradeToUnlockCTA";

const isDev = process.env.NODE_ENV === 'development';

enum WebsiteBuilderTab {
    BUILD = 'build',
    STYLE = 'style',
    CONNECT = 'connect',
    ANALYTICS = 'analytics',
}

const WEBSITE_BUILDER_TABS: TabItem[] = [
    {
        id: WebsiteBuilderTab.BUILD,
        title: 'Build'
    },
    {
        id: WebsiteBuilderTab.STYLE,
        title: 'Style'
    },
    {
        id: WebsiteBuilderTab.CONNECT,
        title: 'Connect'
    },
]

const WEBSITE_BUILDER_TABS_PUBLISHED: TabItem[] = [
    {
        id: WebsiteBuilderTab.BUILD,
        title: 'Build'
    },
    {
        id: WebsiteBuilderTab.STYLE,
        title: 'Style'
    },
    {
        id: WebsiteBuilderTab.CONNECT,
        title: 'Connect'
    },
    {
        id: WebsiteBuilderTab.ANALYTICS,
        title: 'Analytics'
    }
]

const CONTENT_OPTIONS = [
    {
        title: 'Content',
        contentOptions: [
            {
                type: WebsiteBuilderContentType.MUSIC,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.MUSIC).title,
                icon: 'music',
                description: 'Add a music content to your website',
            },
            {
                type: WebsiteBuilderContentType.VIDEO,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.VIDEO).title,
                icon: 'video',
                description: 'Add a video content to your website',
            },
            {
                type: WebsiteBuilderContentType.TOUR,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.TOUR).title,
                icon: 'calendar',
                description: 'Add a tour content to your website',
            },
        ]
    },
    {
        title: 'General',
        contentOptions: [
            {
                type: WebsiteBuilderContentType.EXTERNAL_LINKS,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.EXTERNAL_LINKS).title,
                icon: 'link',
                description: 'Add external links to your website',
            },
            {
                type: WebsiteBuilderContentType.SOCIAL_PLATFORMS,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.SOCIAL_PLATFORMS).title,
                icon: 'audiences',
                description: 'Add social platforms to your website',
            },
            {
                type: WebsiteBuilderContentType.STREAMING_PLATFORMS,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.STREAMING_PLATFORMS).title,
                icon: 'bulletList',
                description: 'Add streaming platforms to your website',
            },
            // {
            //     type: WebsiteBuilderContentType.PAYMENT,
            //     title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.PAYMENT).title,
            //     icon: 'money',
            //     description: 'Add a payment content to your website',
            // },
            {
                type: WebsiteBuilderContentType.IMAGE,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.IMAGE).title,
                icon: 'image',
                description: 'Add an image content to your website',
            },
            {
                type: WebsiteBuilderContentType.TEXT,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.TEXT).title,
                icon: 'bulletList',
                description: 'Add a text content to your website',
            },
            {
                type: WebsiteBuilderContentType.COLLECT_DATA,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.COLLECT_DATA).title,
                icon: 'mail',
                description: 'Add a collect data content to your website',
            },
            {
                type: WebsiteBuilderContentType.TABS,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.TABS).title,
                icon: 'billing',
                description: 'Add a tabs content to your website',
                isPaidOnly: true,
            },
            {
                type: WebsiteBuilderContentType.DIVIDER,
                title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.DIVIDER).title,
                icon: 'menu',
                description: 'Add a divider content to your website',
                isPaidOnly: true,
            },
            // {
            //     type: WebsiteBuilderContentType.PRESAVE,
            //     title: getWebsiteBuilderContentInfo(WebsiteBuilderContentType.PRESAVE).title,
            //     icon: 'personCheck',
            //     description: 'Add a presave content to your website',
            // },
        ]
    },
]

const WebsiteBuilder = () => {
    const history = useHistory();
    const location = useLocation();
    const { websiteSlug: websiteSlugParam } = useParams<{ websiteSlug: string }>();
    const {
        mStyle,
        mobileView,
        mediumView,
        cssCalc
    } = useScreen();

    const {
        currentBrand,
        getBrandImage,
        isPaidBrand,
        isProBrand,
    } = useBrand() as BrandExistsState;

    const {
        getWebsiteAnalytics,
    } = useWebsiteBuilderAnalytics();

    const {
        websiteBuilderData,
        websiteContent,
        websiteStyle,
        setWebsiteContent,
        setWebsiteStyle,
        resetWebsiteBuilder,
        isLoadingWebsiteBuilder,

        isPublishingWebsite,

        getWebsite,
        createWebsite,
        updateWebsite,
        deleteWebsite,

        getSocialPlatforms,

        websiteSlugText,
        setWebsiteSlugText,
        isPublished,

        setShowCreateNewWebsiteModalV2,
        setShowCreateNewWebsiteModal,

        canSaveOrPublishWebsite,
        needsPaidBrand,

        resetWebsiteBuilderLocalStorage
    } = useWebsiteBuilder();

    const websiteId = websiteBuilderData?.id;

    const tabsContent = websiteContent.find(content => content.type === WebsiteBuilderContentType.TABS)?.tabsContent;

    const getFirstMediaContentImage = (): string => {
        for (const content of websiteContent) {
            if (content.musicContent?.selectedMusic?.thumbnail_url) {
                return content.musicContent.selectedMusic.thumbnail_url;
            }
            if (content.imageContent?.image) {
                return content.imageContent.image;
            }
            if (content.videoContent?.thumbnail) {
                return content.videoContent.thumbnail;
            }
        }
        return '';
    };

    const firstMediaImage = getFirstMediaContentImage();

    const {
        backgroundColor,
        secondaryColor,
        textColor,
        fontFamily,
    } = websiteStyle;

    const websiteUrl = `${currentBrand?.slug}/${websiteSlugText}`
    const finalWebsiteLink = `${SYMPHONY_WEBSITE_URL}/${websiteUrl}`;
    const finalWebsiteLinkProd = `https://symphony.to/${websiteUrl}`;
    const renderFontPreContent = ({
        fontFamily,
        isSelected,
    }: {
        fontFamily: string,
        isSelected: boolean,
    }) => {
        return (
            <div
                className="fontContentPreContent"
                style={styx(
                    sty.fontContentPreContent,
                    { fontFamily },
                    isSelected && { color: Colors.purple }
                )}
            >
                <div>Aa</div>
            </div>
        )
    }

    const FONT_THEME_STYLE_OPTIONS = objectToArrayInOrder(fontThemeStyles).map((font: any, index: number) => ({
        label: `${index + 1}/${Object.keys(fontThemeStyles).length}`,
        id: font.title,
        isPaid: font.isPaidOnly,
        childrenLeft: renderFontPreContent({
            fontFamily: font.title,
            isSelected: fontFamily === font.title,
        }),
    }))

    const toastOptions = {
        style: {
            marginTop: 48,
        },
    }

    const [isCustomize, setIsCustomize] = useState<boolean>(false);

    const [showWebsiteBuilderMenu, setShowWebsiteBuilderMenu] = useState<boolean>(false);
    const [isMenuMounted, setIsMenuMounted] = useState<boolean>(false);
    const [selectedWebsiteBuilderTab, setSelectedWebsiteBuilderTab] = useState<TabItem>(WEBSITE_BUILDER_TABS[0]);
    const [selectedContentIndex, setSelectedContentIndex] = useState<number | undefined>(undefined);
    const [showPublishModal, setShowPublishModal] = useState<boolean>(false);
    const [showPublishSuccessModal, setShowPublishSuccessModal] = useState<boolean>(false);
    const [showAreYouSureModal, setShowAreYouSureModal] = useState<boolean>(false);
    const [showNewWebsiteModalAreYouSure, setShowNewWebsiteModalAreYouSure] = useState<boolean>(false);
    const [showWebsiteShareModal, setShowWebsiteShareModal] = useState<boolean>(false);

    const { handleOpenModal: handleOpenUpgradeToProModal } = useContext(UpgradeModalContext);

    const [addAffiliateLinkToLogo, setAddAffiliateLinkToLogo] = useState<boolean>(false);

    const defaultUpgradeModalProps = {
        upgradeCallToAction: "Customize your website with Symphony Lite",
        highlightedPlan: PlanType.LITE,
        successUrl: `website-builder/${websiteUrl}`,
        cancelUrl: `website-builder/${websiteUrl}`,
    }

    // When needed, pass the actual handler through
    const handleUpgradeToPro = (source: string) => {
        handleOpenUpgradeToProModal({
            ...defaultUpgradeModalProps,
            source: source,
        });
    }

    const getWebsiteAndAnalytics = async () => {
        try {
            const websiteLocal = await getWebsite({
                websiteSlug: websiteSlugParam || '',
                brandSlug: currentBrand?.slug,
            });

            if (!websiteLocal) {
                return;
            }

            await getWebsiteAnalytics({
                websiteId: websiteLocal.id,
                startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
                endDate: dayjs().format('YYYY-MM-DD'),
                mock: false,
            });

            // Check for tab=analytics parameter after website data is loaded
            const searchParams = new URLSearchParams(location.search);
            const tabParam = searchParams.get('tab');
            if (tabParam === 'analytics') {
                const analyticsTab = WEBSITE_BUILDER_TABS_PUBLISHED.find(tab => tab.id === 'analytics');
                if (analyticsTab && isPublished()) {
                    setSelectedWebsiteBuilderTab(analyticsTab);
                    if (mobileView) {
                        setIsCustomize(true);
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (websiteSlugParam) {
            setWebsiteSlugText(websiteSlugParam);
            getWebsiteAndAnalytics();
        }

        if (localStorage.getItem('websiteContent')) {
            setWebsiteContent(JSON.parse(localStorage.getItem('websiteContent') || '[]'));
        }

        if (localStorage.getItem('websiteStyle')) {
            setWebsiteStyle(JSON.parse(localStorage.getItem('websiteStyle') || '{}'));
        }

        return () => {
            resetWebsiteBuilder();
        }
    }, []);

    const handleOpenMenu = () => {
        setIsMenuMounted(true);
        setTimeout(() => setShowWebsiteBuilderMenu(true), 50);
    };

    const handleAddContent = (contentType: WebsiteBuilderContentType) => {
        // Check if trying to add tabs and if tabs already exist
        if (contentType === WebsiteBuilderContentType.TABS &&
            websiteContent.some(content => content.type === WebsiteBuilderContentType.TABS)) {
            return; // Exit early if trying to add a second tabs component
        }

        let newContent: Partial<WebsiteBuilderContent> = {
            id: `${contentType}_${Date.now()}`,
            type: contentType,
        };

        switch (contentType) {
            case WebsiteBuilderContentType.COLLECT_DATA:
                newContent.collectDataContent = {
                    title: `Collect Data ${Date.now()}`,
                    buttonText: 'Subscribe',
                    isBothEmailPhone: false,
                    isShowTitles: true,
                    postSubscribeMessage: 'Thank you for subscribing!',
                    info: [
                        {
                            title: 'Email / Phone',
                            placeholder: 'Enter your email / phone',
                            type: CollectDataInputType.EMAIL_PHONE,
                            isRequired: true,
                        },
                        {
                            title: 'Name',
                            placeholder: 'Enter your name',
                            type: CollectDataInputType.TEXT,
                            isRequired: false,
                        },
                    ],
                };
                break;
            case WebsiteBuilderContentType.DIVIDER:
                newContent.dividerContent = {
                    title: `Divider ${Date.now()}`,
                    style: DividerStyle.SOLID,
                };
                break;
            case WebsiteBuilderContentType.EXTERNAL_LINKS:
                newContent.externalLinksContent = {
                    title: `External Links ${Date.now()}`,
                    style: ExternalLinksStyle.STACKED_ROUNDED,
                    platforms: [{
                        title: 'Platform 1',
                        description: 'Description 1',
                        name: 'Platform 1',
                        icon: 'link',
                        link: 'https://platform1.com',
                        isEnabled: true,
                        placeholder: 'Enter link',
                    }],
                };
                break;
            case WebsiteBuilderContentType.IMAGE:
                newContent.imageContent = {
                    isTitle: false,
                    title: "Listen to",
                    image: getBrandImage(),
                    style: ImageContentStyle.SQUARE,
                    isSubtitle: false,
                    subtitle: 'New song name',
                };
                break;
            case WebsiteBuilderContentType.MUSIC:
                newContent.musicContent = {
                    title: `Music ${Date.now()}`,
                    style: MusicContentStyle.ARTWORK,
                };
                break;
            case WebsiteBuilderContentType.PAYMENT:
                newContent.paymentContent = {
                    title: `Payment ${Date.now()}`,
                };
                break;
            case WebsiteBuilderContentType.PRESAVE:
                newContent.presaveContent = {
                    title: `Presave ${Date.now()}`,
                    style: PresaveWebsiteBuilderStyle.BOXES,
                    hideReleaseDate: false,
                    presave: {
                        boosts: {
                            auto_presaves: false,
                            boost_follows: false,
                            collect_emails: false,
                        },
                        platforms: [
                            {
                                name: PresavePlatform.SPOTIFY,
                                isEnabled: true,
                            },
                            {
                                name: PresavePlatform.APPLE_MUSIC,
                                isEnabled: true,
                            },
                            {
                                name: PresavePlatform.DEEZER,
                                isEnabled: false,
                            },
                            {
                                name: PresavePlatform.SOUNDCLOUD,
                                isEnabled: false,
                            },
                            {
                                name: PresavePlatform.AUDIOMACK,
                                isEnabled: false,
                            },
                        ],
                        redirect_url: 'https://example.com',
                        redirect_to_custom_webpage: false,
                        release_date: dayjs().format('YYYY-MM-DD'),
                        timezone: 'America/New_York',
                    }
                };
                break;
            case WebsiteBuilderContentType.SOCIAL_PLATFORMS:
                newContent.socialPlatformsContent = {
                    title: `Social Platforms ${Date.now()}`,
                    platforms: getSocialPlatforms(),
                };
                break;
            case WebsiteBuilderContentType.STREAMING_PLATFORMS:
                newContent.streamingPlatformsContent = {
                    title: `Streaming Platforms ${Date.now()}`,
                    platforms: [],
                    style: StreamingPlatformsStyle.BOXES,
                };
                break;
            case WebsiteBuilderContentType.TABS:
                newContent.tabsContent = {
                    title: `Tabs ${Date.now()}`,
                    activeTab: 'tab1',
                    tabs: [
                        {
                            id: 'tab1',
                            title: 'Tab 1',
                        },
                        {
                            id: 'tab2',
                            title: 'Tab 2',
                        },
                        {
                            id: 'tab3',
                            title: 'Tab 3',
                        },
                    ],
                };
                break;
            case WebsiteBuilderContentType.TEXT:
                newContent.textContent = {
                    title: 'Title',
                    isSubtitle: false,
                    subtitle: ''
                };
                break;
            case WebsiteBuilderContentType.TOUR:
                newContent.tourContent = {
                    title: `Tour ${Date.now()}`,
                    tourDates: [],
                    hidePastTourDates: false,
                    style: TourStyle.BOXES,
                };
                break;
            case WebsiteBuilderContentType.VIDEO:
                newContent.videoContent = {
                    title: `Video ${Date.now()}`,
                    video: '',
                    thumbnail: '',
                    style: VideoContentStyle.SQUARE,
                };
                break;
        }

        if (selectedContentIndex === undefined) {
            setWebsiteContent([...websiteContent, newContent as WebsiteBuilderContent]);
        } else {
            setWebsiteContent([...websiteContent.slice(0, selectedContentIndex), newContent as WebsiteBuilderContent, ...websiteContent.slice(selectedContentIndex)]);
        }

        setSelectedContentIndex(undefined)
    }

    const createWebsite_local = async () => {
        const websiteBuilderDataLocal = await createWebsite();
        return websiteBuilderDataLocal;
    }

    const updateWebsite_local = async () => {
        await updateWebsite();
        toast.success('Website updated successfully!', toastOptions);
    }

    const deleteWebsite_local = async () => {
        if (!websiteId) {
            return;
        }

        await deleteWebsite(websiteId);
    }

    const getTextAlignStyle = (textAlign: WebsiteTextAlign) => {
        switch (textAlign) {
            case WebsiteTextAlign.LEFT:
                return {
                    alignItems: 'flex-start',
                }
            case WebsiteTextAlign.CENTER:
                return {
                    alignItems: 'center',
                }
            case WebsiteTextAlign.RIGHT:
                return {
                    alignItems: 'flex-end',
                }
        }
    }

    const renderTextAlignmentPreContent = ({
        textAlign,
        isSelected
    }: {
        textAlign: WebsiteTextAlign,
        isSelected: boolean
    }) => {
        return (
            <div
                className="textAlignmentPreContent"
                style={styx(
                    sty.textAlignmentPreContent,
                    getTextAlignStyle(textAlign)
                )}
            >
                <div
                    className="textAlignmentPreContentTop"
                    style={styx(
                        sty.textAlignmentPreContentTop,
                        isSelected && { backgroundColor: Colors.purple }
                    )}
                />
                <div
                    className="textAlignmentPreContentBottom"
                    style={styx(
                        sty.textAlignmentPreContentBottom,
                        isSelected && { backgroundColor: Colors.purple }
                    )}
                />
            </div>
        )
    }

    const renderWebsiteUrlLink = () => {
        return (
            <div
                className="rightSideTopBarContentLink"
                style={sty.rightSideTopBarContentLink}
            >
                {mediumView ? null : finalWebsiteLink}
                <ButtonSymphony
                    className="rightSideTopBarContentShareButton"
                    style={{ color: Colors.purpleLight }}
                    onClick={() => setShowWebsiteShareModal(true)}
                    variant="text"
                    size="small"
                >
                    Share
                </ButtonSymphony>
                <ButtonSymphony
                    className="rightSideTopBarContentViewButton"
                    variant="text"
                    size="small"
                    style={{ color: Colors.purpleLight }}
                    onClick={() => {
                        window.open(finalWebsiteLink, '_blank');
                    }}
                >
                    View
                </ButtonSymphony>
                {isDev &&
                    <ButtonSymphony
                        className="rightSideTopBarContentViewButton"
                        variant="text"
                        size="small"
                        color="green"
                        onClick={() => {
                            window.open(finalWebsiteLinkProd, '_blank');
                        }}
                    >
                        View
                    </ButtonSymphony>
                }

                <ButtonSymphony
                    className="rightSideTopBarContentCopyButton"
                    variant="text"
                    size="small"
                    style={{ color: Colors.purpleLight }}
                    onClick={() => {
                        navigator.clipboard.writeText(finalWebsiteLink);
                        toast.success('Copied to clipboard!', toastOptions);
                    }}
                >
                    Copy
                </ButtonSymphony>
                <Icon
                    className="rightSideTopBarContentEditIcon"
                    icon="edit"
                    size={20}
                    color={Colors.purpleLight}
                    onClick={() => {
                        setShowPublishModal(true);
                    }}
                />
            </div>
        )
    }

    const renderPublishSaveChangesButton = () => {
        return (
            <ButtonSymphony
                className="rightSideTopBarPublishSaveChangesButton"
                onClick={async () => {
                    if (needsPaidBrand()) {
                        handleUpgradeToPro("Website Editor - Publish Button")
                        return;
                    }

                    if (isPublished()) {
                        await updateWebsite_local();
                    } else {
                        setShowPublishModal(true) // NOTE: look at publishWebsitePublishButton
                    }
                }}
                isLoading={isPublishingWebsite}
                loadingText="Publishing..."
                disabled={!canSaveOrPublishWebsite()}
            >
                {isPublished() ? 'Save Changes' : 'Publish'}
            </ButtonSymphony>
        )
    }

    const renderRightSideTopBarContent = () => {
        return (
            <div
                className="rightSideTopBarContent"
                style={styx(
                    sty.rightSideTopBarContent,
                    { marginLeft: mobileView ? 'auto' : 0 }
                )}
            >
                {isPublished() &&
                    renderWebsiteUrlLink()
                }
                {/* <ButtonSymphony
                    className="rightSideTopBarContentNewWebsiteButton"
                    onClick={() => setShowNewWebsiteModalAreYouSure(true)}
                    variant="outlined"
                    color="white"
                >
                    New Website
                </ButtonSymphony> */}
                {!mobileView &&
                    renderPublishSaveChangesButton()
                }
                {isPublished() &&
                    <Icon
                        className="rightSideTopBarContentPreviewButtonIcon"
                        onClick={() => setShowAreYouSureModal(true)}
                        icon="trash"
                        size={24}
                        color={Colors.grey}
                    />
                }
            </div>
        )
    }

    const renderDividerLine = (
        style: CSSProperties,
        isDivider: boolean
    ) => {
        if (!isDivider) {
            return null;
        }

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 8,
                    width: '100%',
                    height: 1,
                    backgroundColor: Colors.grey,
                    ...style
                }}
            />
        )
    }

    const renderInlineAddContentButton = ({
        index,
        variant = 'text',
        color = 'purple',
        style = {},
        isDivider = false
    }: {
        index?: number,
        variant?: ButtonVariant,
        color?: ButtonColor,
        style?: CSSProperties,
        isDivider?: boolean
    }) => {
        return (
            <div
                className="inlineAddContentButtonContainer"
                style={styx(
                    sty.inlineAddContentButtonContainer,
                    style
                )}
            >
                {renderDividerLine({ paddingLeft: 16 }, isDivider)}
                <ButtonSymphony
                    className="inlineAddContentButton"
                    style={sty.inlineAddContentButton}
                    iconLeft="addCircle"
                    onClick={() => {
                        handleOpenMenu()
                        setSelectedContentIndex(index)
                    }}
                    variant={variant}
                    color={color}
                >
                    Add Content
                </ButtonSymphony>
                {renderDividerLine({ paddingRight: 16 }, isDivider)}
            </div>
        )
    }

    const renderAddContentButton = (isInPhonePreview: boolean = false) => {
        // if(selectedWebsiteBuilderTab.id !== WebsiteBuilderTab.BUILD) {
        //     return null
        // }

        return (
            <ButtonSymphony
                className="addContentButton"
                style={sty.addContentButton}
                iconLeft="addCircle"
                onClick={handleOpenMenu}
                variant={isInPhonePreview ? 'primary' : 'text'}
                color={isInPhonePreview ? 'white' : 'purple'}
            >
                Add Content
            </ButtonSymphony>
        )
    }

    const renderStyleContent = () => {
        return (
            <>
                <CardSymphony
                    className="colorContentCard"
                    title="Colors"
                    subtitle="Change the background and text colors of your website. (Upload an image in the first slot to automatically generate colors)"
                    size="small"
                >
                    <div className="colorContentColorInputContainer" style={sty.colorContentColorInputContainer}>
                        <div className="colorContentColorInputLabel" style={sty.colorContentColorInputLabel}>
                            Background Color
                        </div>
                        <div className="colorContentPaletteInput" style={sty.colorContentPaletteInput}>
                            <ImagePalette
                                className="colorContentPaletteInputImagePalette1"
                                // imageUrl={musicContent?.selectedMusic?.thumbnail_url || imageContent?.image || ''}
                                imageUrl={firstMediaImage}
                                selectedColor={backgroundColor}
                                selectColor={(color) => setWebsiteStyle({ ...websiteStyle, backgroundColor: color })}
                                showBlackAndWhite
                                isInputColorPicker
                            />
                        </div>
                    </div>
                    <div className="colorContentColorInputContainer" style={sty.colorContentColorInputContainer}>
                        <div className="colorContentColorInputLabel" style={sty.colorContentColorInputLabel}>
                            Secondary Color
                        </div>
                        <div className="colorContentPaletteInput" style={sty.colorContentPaletteInput}>
                            <ImagePalette
                                className="colorContentPaletteInputImagePalette2"
                                // imageUrl={musicContent?.selectedMusic?.thumbnail_url || imageContent?.image || ''}
                                imageUrl={firstMediaImage}
                                selectedColor={secondaryColor}
                                selectColor={(color) => setWebsiteStyle({ ...websiteStyle, secondaryColor: color })}
                                showBlackAndWhite
                                isInputColorPicker
                            />
                        </div>
                    </div>
                    {/* <div className="colorContentColorInputContainer" style={sty.colorContentColorInputContainer}>
                        <div className="colorContentColorInputLabel" style={sty.colorContentColorInputLabel}>
                            Text Color
                        </div>
                        <div className="colorContentPaletteInput" style={sty.colorContentPaletteInput}>
                            <ImagePalette
                                // imageUrl={musicContent?.selectedMusic?.thumbnail_url || imageContent?.image || ''}
                                imageUrl={firstMediaImage}
                                selectedColor={textColor}
                                selectColor={(color) => setWebsiteStyle({ ...websiteStyle, textColor: color })}
                                showBlackAndWhite
                                isInputColorPicker
                            />
                        </div>
                    </div> */}
                </CardSymphony>

                <CardSymphony
                    className="fontContentCard"
                    title="Font"
                    subtitle="Change the font of your website"
                    size="small"
                >
                    <div className="optionsScrollContainer" style={sty.optionsScrollContainer}>
                        <OptionsSymphony
                            className="fontContentInput"
                            options={FONT_THEME_STYLE_OPTIONS}
                            value={fontFamily}
                            handleOptionSelected={(option) => {
                                const fontThemeStyle = FONT_THEME_STYLE_OPTIONS.find(font => font.id === option);
                                if (!isPaidBrand && fontThemeStyle?.isPaid) {
                                    handleUpgradeToPro("Website Editor - Font Theme Styles")
                                    return;
                                }
                                setWebsiteStyle({ ...websiteStyle, fontFamily: option as string });
                            }}
                            size="small"
                            isRadio={false}
                        />
                    </div>
                </CardSymphony>

                <CardSymphony
                    className="textAlignContentCard"
                    title="Text Alignment"
                    subtitle="Change the text alignment of your website"
                    size="small"
                >
                    <OptionsSymphony
                        className="textAlignInput"
                        styleOptionRow={{
                            width: 70,
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                        options={[
                            {
                                id: WebsiteTextAlign.LEFT,
                                childrenLeft: renderTextAlignmentPreContent({
                                    textAlign: WebsiteTextAlign.LEFT,
                                    isSelected: websiteStyle.textAlign === WebsiteTextAlign.LEFT
                                })
                            },
                            {
                                id: WebsiteTextAlign.CENTER,
                                childrenLeft: renderTextAlignmentPreContent({
                                    textAlign: WebsiteTextAlign.CENTER,
                                    isSelected: websiteStyle.textAlign === WebsiteTextAlign.CENTER
                                })
                            },
                            {
                                id: WebsiteTextAlign.RIGHT,
                                childrenLeft: renderTextAlignmentPreContent({
                                    textAlign: WebsiteTextAlign.RIGHT,
                                    isSelected: websiteStyle.textAlign === WebsiteTextAlign.RIGHT
                                })
                            }
                        ]}
                        value={websiteStyle.textAlign}
                        handleOptionSelected={(option) => {
                            setWebsiteStyle({ ...websiteStyle, textAlign: option as WebsiteTextAlign });
                        }}
                        size="small"
                        isRadio={false}
                    />
                </CardSymphony>

                <SymphonyLogoEditorCard
                    selectedSymphonyLogoStyle={websiteStyle.symphonyLogoStyle}
                    setSelectedSymphonyLogoStyle={(styleId) => setWebsiteStyle({ ...websiteStyle, symphonyLogoStyle: styleId })}
                    removeSymphonyBrand={!websiteStyle.isSymphonyLogoEnabled}
                    onChangeShowSymphonyLogo={(checked) => setWebsiteStyle({ ...websiteStyle, isSymphonyLogoEnabled: checked })}
                    onUpgradeClick={() => {
                        handleUpgradeToPro("Website Editor - Symphony Logo Editor Card")
                    }}
                    addAffiliateLinkToLogo={addAffiliateLinkToLogo}
                />
            </>
        )
    }

    const renderConnectContent = () => {
        return (
            <ConnectSection className="connectSectionFromWebsiteBuilder" />
        )
    }

    const renderContentOptions = () => {
        return (
            <div className="contentOptionsContainer" style={sty.contentOptionsContainer}>
                {CONTENT_OPTIONS.map((optionGroup, groupIndex) => (
                    <div
                        key={makeKey('group', groupIndex)}
                        className="contentOptionGroup"
                        style={sty.contentOptionGroup}
                    >
                        <div className="contentOptionGroupTitle" style={sty.contentOptionGroupTitle}>
                            {optionGroup.title}
                        </div>
                        <div
                            className="contentOptionGrid"
                            style={mStyle(sty, 'contentOptionGrid')}
                        >
                            {optionGroup.contentOptions.map((contentOption, optionIndex) => {
                                const isTabsDisabled = contentOption.type === WebsiteBuilderContentType.TABS && websiteContent.some(content => content.type === WebsiteBuilderContentType.TABS);
                                const isCollectDataDisabled = contentOption.type === WebsiteBuilderContentType.COLLECT_DATA && websiteContent.some(content => content.type === WebsiteBuilderContentType.COLLECT_DATA);

                                const isContentDisabled = isTabsDisabled || isCollectDataDisabled;

                                const {
                                    isPaidOnly,
                                } = contentOption;

                                return (
                                    <div
                                        key={makeKey(contentOption.type, optionIndex)}
                                        className="contentOption"
                                        style={styx(
                                            sty.contentOption,
                                            isContentDisabled && {
                                                opacity: 0.5,
                                                cursor: 'not-allowed',
                                                backgroundColor: Colors.greyLight
                                            }
                                        )}
                                        onClick={() => {
                                            if (!isContentDisabled) {
                                                handleAddContent(contentOption.type)
                                                setShowWebsiteBuilderMenu(false)
                                            }
                                        }}
                                    >
                                        <div
                                            className="contentOptionIconContainer"
                                            style={sty.contentOptionIconContainer}
                                        >
                                            <Icon
                                                className="contentOptionIcon"
                                                icon={contentOption.icon}
                                                size={32}
                                                color={isContentDisabled ? Colors.grey : Colors.greyDark}
                                            />
                                        </div>
                                        <div className="contentOptionTitleContainer" style={sty.contentOptionTitleContainer}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                                <div
                                                    className="contentOptionTitle"
                                                    style={styx(
                                                        Sty.text16,
                                                        isContentDisabled && { color: Colors.grey }
                                                    )}
                                                >
                                                    {contentOption.title}
                                                </div>
                                                {isPaidOnly &&
                                                    <Icon className="contentOptionTitleIcon" icon="gem" size={16} color={Colors.purple} />
                                                }
                                            </div>
                                            <div className="contentOptionDescription" style={Sty.text14grey}>
                                                {contentOption.description}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                ))}
                <UpgradeToUnlockCTA
                    className="contentOptionsUpgradeToUnlockCTA"
                    requiresPaidPlan={!isPaidBrand}
                    buttonText="Upgrade to unlock Premium Themes"
                    upgradeSource="Website Builder - Content Options"
                    paywallText="Upgrade to Lite or Pro to unlock all content options."
                />
            </div>
        )
    }

    const renderWebsiteBuilderMenu = () => {
        if (!showWebsiteBuilderMenu && !isMenuMounted) {
            return null;
        }

        return (
            <div
                className="websiteBuilderMenuOverlay"
                style={styx(
                    sty.websiteBuilderMenuOverlay,
                    { opacity: showWebsiteBuilderMenu ? 1 : 0 }
                )}
                onClick={() => setShowWebsiteBuilderMenu(false)}
                onTransitionEnd={() => {
                    if (!showWebsiteBuilderMenu) {
                        setIsMenuMounted(false);
                    }
                }}
            >
                <div
                    className="websiteBuilderMenu"
                    style={styx(
                        sty.websiteBuilderMenu,
                        { transform: showWebsiteBuilderMenu ? 'translateX(0)' : 'translateX(-100%)' }
                    )}
                    onClick={(e) => e.stopPropagation()}
                >
                    <Icon
                        className="websiteBuilderMenuCloseIcon"
                        style={sty.websiteBuilderMenuCloseIcon}
                        icon="close"
                        isCircle
                        color={Colors.greyDark}
                        onClick={() => setShowWebsiteBuilderMenu(false)}
                    />
                    <CardSymphony
                        className="websiteBuilderMenuCard"
                        title="Add Content"
                        isNoPadding
                        style={{ marginBottom: 16 }}
                    />
                    {renderContentOptions()}
                </div>
            </div>
        )
    }

    const renderTabSelector = (contentIndex: number) => {
        const websiteContentItem = websiteContent[contentIndex];
        if (!tabsContent) {
            return null;
        }

        return (
            <InputSymphony
                className="tabSelectorWebsiteBuilderHeader"
                style={sty.tabSelectorWebsiteBuilderHeader}
                isSelectDropdown
                placeholder="Select Tab"
                value={websiteContentItem.tabId || ''}
                options={[
                    { title: 'No Tab', value: '' },
                    ...(tabsContent?.tabs.map(tab => ({
                        title: tab.title,
                        value: tab.id,
                    })) || [])
                ] as SelectOptionItem[]}
                onOptionSelect={(option) => {
                    setWebsiteContent([...websiteContent.slice(0, contentIndex), { ...websiteContentItem, tabId: option.value }, ...websiteContent.slice(contentIndex + 1)]);
                }}
            />
        )
    }

    const renderWebsiteBuilderContent = (content: WebsiteBuilderContent, contentIndex: number, dragHandleProps?: any) => {
        const sharedProps = {
            id: `website-builder-content-scroll-${contentIndex}`,
            className: content.id,
        }

        switch (content.type) {
            case WebsiteBuilderContentType.COLLECT_DATA:
                return (
                    <CollectDataContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.DIVIDER:
                return (
                    <DividerContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.EXTERNAL_LINKS:
                return (
                    <ExternalLinksContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.IMAGE:
                return (
                    <ImageContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.MUSIC:
                return (
                    <MusicContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.PAYMENT:
                return (
                    <PaymentContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.PRESAVE:
                return (
                    <PresaveContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.SOCIAL_PLATFORMS:
                return (
                    <SocialPlatformsContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.STREAMING_PLATFORMS:
                return (
                    <StreamingPlatformsContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.TABS:
                return (
                    <TabsContent
                        contentIndex={contentIndex}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.TEXT:
                return (
                    <TextContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.TOUR:
                return (
                    <TourContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            case WebsiteBuilderContentType.VIDEO:
                return (
                    <VideosContent
                        contentIndex={contentIndex}
                        tabSelectorComponent={renderTabSelector(contentIndex)}
                        {...sharedProps}
                    />
                )
            default:
                return null
        }
    }

    const renderAnalyticsContent = () => {
        return (
            <WebsiteBuilderAnalytics />
        )
    }

    const renderExploreTemplatesButton = () => {
        return (
            <ButtonSymphony
                className="websiteBuilderBannerButton"
                onClick={() => setShowCreateNewWebsiteModalV2(true)}
                variant="outlined"
            >
                Explore Templates
            </ButtonSymphony>
        )
    }

    const renderUpgradeToLiteButton = () => {
        if (!isProBrand && !isPaidBrand) {
            return (
                <ButtonSymphony
                    className="websiteBuilderUpgradeButton"
                    onClick={() => handleUpgradeToPro("Website Editor - Empty State")}
                    variant="primary"
                    color="purple"
                >
                    Upgrade to Lite
                </ButtonSymphony>
            )
        }
    }

    const renderWebsiteBuilder = () => {
        return (
            <div
                className="websiteBuilderInnerContainer"
                style={sty.websiteBuilderInnerContainer}
            >
                <TabsSymphony
                    className="websiteBuilderTabs"
                    style={mStyle(sty, 'websiteBuilderTabs')}
                    tabs={isPublished() ? WEBSITE_BUILDER_TABS_PUBLISHED : WEBSITE_BUILDER_TABS}
                    selectedTab={selectedWebsiteBuilderTab}
                    onChange={(tab) => {
                        setSelectedWebsiteBuilderTab(tab as TabItem);
                    }}
                // rightSideContent={renderAddContentButton()}
                // rightSideContent={
                //     <>
                //         {websiteContent.length > 0 &&
                //             renderExploreTemplatesButton()
                //         }
                //     </>
                // }
                />

                {/* BUILD TAB */}
                <TabSymphony
                    className="websiteBuilderContent"
                    style={sty.websiteBuilderContent}
                    visible={selectedWebsiteBuilderTab.id === 'build'}
                >
                    {websiteContent.length !== 0 &&
                        <WebsiteBuilderEmptyState
                            className="exploreTemplateBanner"
                            style={{
                                gap: 8,
                                paddingTop: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                paddingRight: 8,
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                            isImage={false}
                        >
                            {renderExploreTemplatesButton()}
                            {renderUpgradeToLiteButton()}
                        </WebsiteBuilderEmptyState>
                    }
                    {websiteContent.length === 0 &&
                        <div
                            className="websiteBuilderEmptyStateContainer"
                            style={mStyle(sty, 'websiteBuilderEmptyStateContainer')}
                        >
                            <WebsiteBuilderEmptyState
                                className="websiteBuilderEmptyStateFromWebsiteBuilder"
                                title="Start by adding content here"
                                subtitle="You can add sections to display songs, videos, images, social links, contact forms..."
                                description="Or start with a template"
                            >
                                <div
                                    className="websiteBuilderEmptyStateButtons"
                                    style={sty.websiteBuilderEmptyStateButtons}
                                >
                                    {renderExploreTemplatesButton()}
                                    {renderUpgradeToLiteButton()}
                                    {/* {renderInlineAddContentButton({
                                        variant: 'outlined',
                                        style: {
                                            paddingLeft: 16,
                                            paddingRight: 16
                                        }
                                    })} */}
                                </div>
                                {/* <div>
                                Or Start with a Template
                            </div> */}
                                {/* <ButtonSymphony
                                className="websiteBuilderBannerButton"
                                // onClick={() => setShowCreateNewWebsiteModalV2(true)}
                                onClick={() => setShowCreateNewWebsiteModal(true)}
                            >
                                Start with a Template
                            </ButtonSymphony> */}
                            </WebsiteBuilderEmptyState>
                        </div>
                    }
                    {renderInlineAddContentButton({
                        index: 0,
                        color: 'grey',
                        isDivider: true
                    })}
                    {websiteContent.length > 0 &&
                        <DraggableList
                            id="websiteBuilderContentDraggableList"
                            list={websiteContent}
                            keyOfItem="type"
                            updateList={(newList) => setWebsiteContent(newList)}
                            isDragHandle
                            isGap={false}
                            renderItem={(item, index, dragHandleProps) => {
                                const contentTabId = websiteContent[index].tabId;
                                const activeTabId = tabsContent?.activeTab;
                                const isVisible = !(websiteContent[index].type !== WebsiteBuilderContentType.TABS && contentTabId && activeTabId !== contentTabId);

                                return (
                                    <div
                                        className="websiteBuilderContentItemOuter"
                                        style={{
                                            position: 'relative',
                                            display: isVisible ? 'block' : 'none', // Hide instead of returning null
                                        }}
                                    >
                                        <div
                                            {...dragHandleProps}
                                            className="websiteBuilderContentDragHandle"
                                            style={{
                                                position: 'absolute',
                                                left: -6,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: mobileView ? 28 : 40,
                                                height: mobileView ? 24 : 40,
                                                cursor: 'grab',
                                            }}
                                            ref={(el) => {
                                                if (el && $) {
                                                    const $el = $(el);
                                                    const $header = $el.closest('.websiteBuilderContentItemOuter').find('.websiteBuilderHeader');
                                                    if ($header.length) {
                                                        const headerHeight = $header.outerHeight() || 0;
                                                        $el.css('top', 24 + (headerHeight / 2) - 20 + 'px');
                                                    }
                                                }
                                            }}
                                        >
                                            <Icon
                                                className="websiteBuilderContentDragHandleIcon"
                                                icon="drag"
                                                size={24}
                                                color={Colors.grey}
                                            />
                                        </div>
                                        {isVisible && renderWebsiteBuilderContent(item, index, dragHandleProps)}
                                        {isVisible && renderInlineAddContentButton({
                                            index: index + 1,
                                            color: 'grey',
                                            style: {
                                                marginTop: 16,
                                                marginBottom: 16
                                            },
                                            isDivider: true
                                        })}
                                    </div>
                                )
                            }}
                        />
                    }
                </TabSymphony>

                {/* STYLE TAB */}
                <TabSymphony
                    className="websiteBuilderContent"
                    style={sty.websiteBuilderContent}
                    visible={selectedWebsiteBuilderTab.id === 'style'}
                >
                    {renderStyleContent()}
                </TabSymphony>

                {/* CONNECT TAB */}
                <TabSymphony
                    className="websiteBuilderContent"
                    style={sty.websiteBuilderContent}
                    visible={selectedWebsiteBuilderTab.id === 'connect'}
                >
                    {renderConnectContent()}
                </TabSymphony>

                {/* ANALYTICS TAB */}
                <TabSymphony
                    className="websiteBuilderContent"
                    style={sty.websiteBuilderContent}
                    visible={selectedWebsiteBuilderTab.id === 'analytics'}
                >
                    {renderAnalyticsContent()}
                </TabSymphony>
            </div>
        )
    }

    const renderWebsiteBuilderMobileFooter = () => {
        return (
            <div
                className="websiteBuilderMobileFooter"
                style={sty.websiteBuilderMobileFooter}
            >
                <ButtonSymphony
                    className="websiteBuilderMobileFooterCustomizeButton"
                    color="white"
                    onClick={() => {
                        setIsCustomize(!isCustomize)
                    }}
                >
                    {isCustomize ? 'Done' : 'Customize'}
                </ButtonSymphony>
                {renderPublishSaveChangesButton()}
            </div>
        )
    }

    // NOTE: render()
    return (
        <>
            {renderWebsiteBuilderMenu()}
            <TopBar
                className="websiteBuilderTopBar"
                style={mobileView ?
                    {
                        overflowX: 'scroll',
                        justifyContent: 'flex-start',
                        gap: 0,
                        scrollbarWidth: 'none',
                    }
                    :
                    {}
                }
                title={mobileView ? null : "Build a Website"}
                handleClose={() => {
                    resetWebsiteBuilderLocalStorage();
                    smartGoBack(history, '/website')
                }}
                hideGetSupportLabel
                isCloseIcon
                renderRightSideContent={renderRightSideTopBarContent()}
            />
            <PageSymphony
                className={clsx('websiteBuilderComponent')}
                style={styx(
                    mStyle(sty, 'websiteBuilderComponent'),
                )}
                isContent
            >
                {/* <DebugBox
                    alwaysShow
                    data={{
                        websiteContent,
                    }}
                /> */}
                {isLoadingWebsiteBuilder ?
                    <Loader
                        className="websiteBuilderLoader"
                        size={32}
                        title="Loading Website Builder..."
                        isCentered
                    />
                    :
                    <div
                        className="websiteBuilderContainer"
                        style={styx(
                            sty.websiteBuilderContainer,
                            mobileView && {
                                height: cssCalc(64 + 72),
                                backgroundColor,
                                overflowY: 'scroll',
                                overflowX: 'hidden',
                            },
                        )}
                    >
                        {!mobileView && renderWebsiteBuilder()}
                        <WebsiteBuilderPhonePreview
                            className="websiteBuilderPhonePreviewFromWebsiteBuilder"
                            addContentButton={renderAddContentButton(true)}
                            isPhone={!mobileView}
                            isFooter={false}
                            onClickContentBlock={(index) => {
                                // Scroll to the content block in the main editor when clicked in the phone preview
                                const contentElement = document.getElementById(`website-builder-content-scroll-${index}`);
                                if (contentElement) {
                                    contentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

                                    // Highlight the content temporarily to make it more visible
                                    contentElement.classList.add('highlight-content');
                                    setTimeout(() => {
                                        contentElement.classList.remove('highlight-content');
                                    }, 1500);
                                }
                            }}
                        />
                    </div>
                }

                {mobileView && renderWebsiteBuilderMobileFooter()}
                {mobileView &&
                    <div
                        className="websiteBuilderMobileCustomizeContainer"
                        style={styx(
                            sty.websiteBuilderMobileCustomizeContainer,
                            isCustomize && sty.websiteBuilderMobileCustomizeContainer_open,
                            { height: cssCalc(64 + 72) },
                        )}
                    >
                        {renderWebsiteBuilder()}
                    </div>
                }
            </PageSymphony>

            {/* MODALS */}
            <ModalSymphony
                className="publishWebsiteBuilderModal"
                isOpen={showPublishModal}
                onClose={() => setShowPublishModal(false)}
                title={isPublished() ? "Update Website" : "Let's go live!"}
                subtitle={isPublished() ? "You can customize your website URL slug." : "You can customize your website URL slug before publishing."}
                style={{ gap: 16 }}
            >
                <InputSymphony
                    className="publishWebsiteBuilderModalInput"
                    value={websiteSlugText}
                    onChange={(value) => setWebsiteSlugText(value.toLowerCase().replace(/[^a-z0-9-_]/g, ''))}
                    preText={`${SYMPHONY_WEBSITE_URL}/${currentBrand?.slug}/`}
                    placeholder="your-website-name"
                    label="Website URL"
                />
                <ButtonSymphony
                    className="publishWebsiteResetButton"
                    onClick={() => setWebsiteSlugText(websiteBuilderData?.slug ?? '')}
                    variant="text"
                >
                    Reset to Original URL
                </ButtonSymphony>
                <ButtonSymphony
                    className="publishWebsitePublishButton"
                    onClick={async () => {
                        if (!websiteSlugText) {
                            return;
                        }

                        if (isPublished()) {
                            await updateWebsite_local();
                        } else {
                            const websiteBuilderDataLocal = await createWebsite_local();
                            if (!websiteBuilderDataLocal) {
                                return;
                            }

                            setShowPublishSuccessModal(true);
                            const brandSlug = currentBrand?.slug ?? '';
                            const websiteSlug = websiteBuilderDataLocal?.slug ?? '';
                            history.push(`/website-builder/${brandSlug}/${websiteSlug}`);
                        }

                        setShowPublishModal(false);
                    }}
                    width="100%"
                    isLoading={isPublishingWebsite}
                    loadingText="Publishing..."
                    disabled={!websiteSlugText || !canSaveOrPublishWebsite()}
                >
                    {isPublished() ? 'Save Changes' : 'Publish'}
                </ButtonSymphony>
            </ModalSymphony>

            {showPublishSuccessModal &&
                <PublishedWebsiteModal
                    className="publishedWebsiteModal"
                    isOpen={showPublishSuccessModal}
                    onClose={() => setShowPublishSuccessModal(false)}
                    websiteUrl={`${SYMPHONY_WEBSITE_URL}/${currentBrand?.slug}/${websiteBuilderData?.slug}`}
                    onClickViewWebsiteAnalytics={() => {
                        setShowPublishSuccessModal(false)
                        setSelectedWebsiteBuilderTab({ id: 'analytics', title: 'Analytics' })
                    }}
                />
            }

            <ModalSymphony
                className="publishWebsiteAreYouSureModal"
                isOpen={showAreYouSureModal}
                onClose={() => setShowAreYouSureModal(false)}
                title="Are you sure you want to delete this website?"
                subtitle="This action cannot be undone."
                style={{ gap: 16 }}

                buttonRightText="Delete Website"
                buttonRightIsLoading={isLoadingWebsiteBuilder}
                buttonRightDisabled={isLoadingWebsiteBuilder}
                buttonRightColor="red"
                onClickButtonRight={async () => {
                    await deleteWebsite_local()
                    history.push('/website')
                    resetWebsiteBuilder()
                    setShowPublishModal(false)
                    setShowAreYouSureModal(false)
                }}
                onClickButtonLeft={() => setShowAreYouSureModal(false)}
                buttonLeftText="Cancel"
                buttonLeftVariant="outlined"
            />

            <ModalSymphony
                className="publishWebsiteAreYouSureModal"
                isOpen={showNewWebsiteModalAreYouSure}
                onClose={() => setShowNewWebsiteModalAreYouSure(false)}
                title="Are you sure you want to create a new website?"
                subtitle="This action will erase all current unsaved and unpublished changes."
                style={{ gap: 16 }}

                buttonRightText="Create New Website"
                buttonRightIsLoading={isLoadingWebsiteBuilder}
                buttonRightDisabled={isLoadingWebsiteBuilder}
                onClickButtonRight={async () => {
                    resetWebsiteBuilder()
                    history.push('/website-builder')
                    setShowNewWebsiteModalAreYouSure(false)
                }}

                onClickButtonLeft={() => setShowNewWebsiteModalAreYouSure(false)}
                buttonLeftText="Cancel"
                buttonLeftVariant="outlined"
            />

            <WebsiteShareModal
                className="websiteShareModalFromWebsiteBuilder"
                isOpen={showWebsiteShareModal}
                onClose={() => setShowWebsiteShareModal(false)}
                websiteUrl={`${SYMPHONY_WEBSITE_URL}/${currentBrand?.slug}/${websiteBuilderData?.slug}`}
            />
        </>
    )
}

const sty: Record<string, CSSProperties> = {
    websiteBuilderComponent: {
        display: 'flex',
        gap: 16,
        // overflowX: 'scroll',
        paddingTop: 0,
    },
    websiteBuilderComponent_mobile: {
        // padding: 16,
    },
    websiteBuilderContainer: {
        display: 'flex',
        gap: 16,
        width: '100%',
    },
    websiteBuilderContainer_mobile: {
        overflowY: 'scroll',
    },
    websiteBuilderInnerContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        width: '100%',
        maxWidth: 834,
    },
    websiteBuilderTabs: {
        position: 'sticky',
        top: 64,
        width: '100%',
        zIndex: 1,
        backgroundColor: 'white',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        paddingLeft: 16,
        paddingRight: 16,
        boxShadow: Sty.boxShadow,
    },
    websiteBuilderTabs_mobile: {
        top: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    websiteBuilderContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        width: '100%',
    },
    websiteBuilderMenuOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
        transition: 'opacity 0.3s ease',
    },
    websiteBuilderMenu: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        zIndex: 1000,
        maxWidth: 600,
        boxShadow: Sty.boxShadowRight,
        overflowY: 'scroll',
        padding: 16,
        transition: 'transform 0.3s ease',
    },
    websiteBuilderMenuCloseIcon: {
        position: 'absolute',
        top: 16,
        right: 16,
        cursor: 'pointer',
        backgroundColor: Colors.greyLight,
        alignSelf: 'flex-start',
    },
    contentOptionsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        width: '100%',
    },
    contentOptionGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
    },
    contentOptionGroupTitle: {
        ...Sty.text18bold,
    },
    contentOptionGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 16,
    },
    contentOptionGrid_mobile: {
        gridTemplateColumns: 'repeat(2, 1fr)',
    },
    contentOption: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        // padding: 16,
        borderRadius: 16,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        overflow: 'hidden',
        border: `1px solid ${Colors.greyLighter}`,
    },
    contentOptionIconContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: 16,
        backgroundColor: Colors.greyLighter,
    },
    contentOptionTitle: {
        color: Colors.greyDark,
    },
    contentOptionTitleContainer: {
        width: '100%',
        padding: 8,
    },
    addContentButton: {
    },

    tabSelectorWebsiteBuilderHeader: {
        minWidth: 145,
        maxWidth: 145,
    },

    colorContentColorInputContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },
    colorContentPaletteInput: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    colorContentColorInputLabel: {
        ...Sty.text14grey,
    },
    colorPaletteDivider: {
        height: 32,
        width: 1,
        backgroundColor: Colors.grey,
        marginLeft: 8,
        marginRight: 8,
    },
    inlineAddContentButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: 8,
        color: Colors.greyLight,
        paddingLeft: 72,
        paddingRight: 72,
    },

    rightSideTopBarContent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    rightSideTopBarContentLink: {
        color: Colors.grey,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        cursor: 'pointer',
        paddingLeft: 16,
        paddingRight: 8,
        paddingTop: 8,
        paddingBottom: 8,
        borderRadius: 8,
    },

    fontContentPreContent: {
        fontSize: 24,
        color: Colors.greyDark,
        height: 52,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    optionsScrollContainer: {
        overflowX: 'scroll',
        width: '100%',
        scrollbarWidth: 'none',
    },

    textAlignmentPreContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        paddingTop: 16,
        paddingBottom: 16,
        width: '100%',
        flexShrink: 0,
        marginLeft: 4,
    },
    textAlignmentPreContentTop: {
        height: 7,
        width: 24,
        borderRadius: 100,
        backgroundColor: Colors.grey,
        flexShrink: 0,
    },
    textAlignmentPreContentBottom: {
        height: 7,
        width: 12,
        borderRadius: 100,
        backgroundColor: Colors.grey,
        flexShrink: 0,
    },

    websiteBuilderBanner: {
        border: `1px dashed ${Colors.purple}`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
    },

    websiteBuilderEmptyStateContainer: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
    },
    websiteBuilderEmptyStateContainer_mobile: {
        paddingLeft: 16,
        paddingRight: 16,
    },
    websiteBuilderMobileFooter: {
        display: 'flex',
        position: 'fixed',
        justifyContent: 'space-between',
        bottom: 0,
        left: 0,
        width: '100%',
        gap: 8,
        padding: 16,
        backgroundColor: Colors.purpleDark,
        zIndex: 2,
    },

    websiteBuilderMobileCustomizeContainer: {
        width: '100%',
        position: 'fixed',
        top: 64,
        left: 0,
        height: '100%',
        backgroundColor: Colors.greyLight,
        zIndex: 1,
        transform: 'translateY(100%)',
        transition: 'transform 0.3s ease-in-out',
        overflowY: 'scroll',
    },
    websiteBuilderMobileCustomizeContainer_open: {
        transform: 'translateY(0)',
    },
    websiteBuilderEmptyStateButtons: {
        display: 'flex',
        flexDirection: 'row',
        gap: 16,
    },
}

export default WebsiteBuilder;